import { supabase } from '../lib/supabase';

const PHOTO_BUCKET = 'booking-photos';

export const uploadPhotos = async (bookingId, files, convertToWebP, logErrorFn) => {
  await Promise.all(files.map(async (file) => {
    try {
      const converted = await convertToWebP(file);
      const ext  = converted.name.split('.').pop() || 'webp';
      const path = `bookings/${bookingId}/${Date.now()}_${Math.random().toString(36).slice(2)}.${ext}`;
      const { error: uploadErr } = await supabase.storage
        .from(PHOTO_BUCKET).upload(path, converted, { contentType: converted.type, upsert: false });
      if (uploadErr) throw new Error(uploadErr.message);
      await supabase.from('booking_photos').insert([{
        booking_id: bookingId, storage_path: path,
        file_name: converted.name, file_type: converted.type, photo_type: 'reference',
      }]);
    } catch (err) {
      if (logErrorFn) await logErrorFn('general', `Photo upload failed for ${file.name}: ${err.message}`, { booking_id: bookingId });
    }
  }));
};
